import { Button, HStack, Icon, IconButton, Stack, Text, VStack } from '@genial/components';
import React from 'react';

interface DocumentsCenterItemProps {
  title: string;
  titleNote?: string;
  url?: string;
  description: string[];
  isMobile: boolean;
  onOpenFile: (url: string) => void;
}

export const DocumentsCenterItem: React.FC<DocumentsCenterItemProps> = ({
  title,
  titleNote,
  url,
  description,
  isMobile,
  onOpenFile,
}) => {
  return (
    <Stack
      direction={{ base: 'row' }}
      space={{ base: 'stack.nano', sm: 'stack.quarck' }}
      justifyContent="space-between"
      borderRadius="sm"
      padding="inline.xxxs"
      borderWidth={1}
      borderColor="neutral.lightest">
      <HStack space="stack.nano" flex={1} alignItems="center">
        <Icon name="PageContent" size="xxxs" />
        <VStack space="stack.quarck" maxWidth={{ base: '100%', sm: '70%', lg: '60%' }} flex={1}>
          <HStack space="stack.nano">
            <Text variant="semibold" fontSize="lg">
              {title}
            </Text>
            <Text variant="regular" fontSize="lg" color="neutral.medium">
              {titleNote}
            </Text>
          </HStack>
          <Text
            ellipsizeMode="tail"
            flex={1}
            numberOfLines={1}
            variant="regular"
            color="neutral.medium">
            {description}
          </Text>
        </VStack>
      </HStack>
      {!isMobile ? (
        <Button
          variant="textLink"
          onPress={() => onOpenFile(url || '')}
          leftIcon={<Icon name="ArrowDownload" size="xxxs" color="brand.tertiary.principal" />}>
          Baixar
        </Button>
      ) : (
        <IconButton
          testId="download-button"
          icon="ArrowDownload"
          onPress={() => onOpenFile(url || '')}
          iconColor="brand.tertiary.principal"
          iconSize="xxxs"
        />
      )}
    </Stack>
  );
};
